import { Icons } from '@assets';
import { IAcl, INavMenuItem } from '@types';
import { isAllow } from '@utils/functions';

const { HeaderIcons } = Icons;

export const booking = (rules: IAcl | undefined): INavMenuItem[] => [
    {
        name: 'Бронирование ',
        desc: 'Бронирование ',
        icon: <img src={HeaderIcons.IconHeaderBooking} alt="icon crm" />,
        to: '/booking/reservation',
        text: 'booking_reservation',
        navKey: 'booking.reservation',
        isAllow: isAllow(rules, 'booking.reservation'),
        subs: [
            {
                name: 'Бронирование ',
                to: '/booking/reservation',
                text: 'booking_reservation',
                navKey: 'booking.reservation',
                isAllow: isAllow(rules, 'booking.reservation'),
            },
            {
                name: 'Забронированные столы',
                to: '/booking/reserved-tables',
                text: 'booking_reserved_tables',
                navKey: 'booking.reserved.tables',
                isAllow: isAllow(rules, 'booking.reserved.tables'),
            },
        ],
    },
    {
        name: 'Журнал',
        desc: 'Журнал',
        icon: <img src={HeaderIcons.IconHeaderBooking} alt="icon booking" />,
        to: '/booking/reports',
        text: 'booking_reports',
        navKey: 'booking.reports',
        isAllow: isAllow(rules, 'booking.promo'),
        subs: [
            {
                name: 'Звонки',
                to: '/booking/reports',
                text: 'booking_reports',
                navKey: 'booking.reports',
                isAllow: isAllow(rules, 'booking.promo.afishi'),
            },
        ],
    },

    {
        name: 'Статистика ',
        desc: 'Статистика ',
        icon: <img src={HeaderIcons.IconHeaderBooking} alt="icon booking" />,
        to: '/booking/booking',
        text: 'booking_booking',
        navKey: 'booking.booking',
        isAllow: isAllow(rules, 'booking.booking'),
        subs: [
            {
                name: 'Отчет по бронированию ',
                to: '/booking/booking',
                text: 'booking_booking_report',
                navKey: 'booking.report',
                isAllow: isAllow(rules, 'booking.report'),
            },
            {
                name: 'Отчет по звонкам ',
                to: '/booking/callsreport',
                text: 'booking_callsreport',
                navKey: 'booking.callsreport',
                isAllow: isAllow(rules, 'booking.callsreport'),
            },
        ],
    },
    {
        name: 'Promo ',
        desc: 'Promo ',
        icon: <img src={HeaderIcons.IconHeaderBooking} alt="icon booking" />,
        to: '/booking/booking',
        text: 'booking_promo',
        navKey: 'booking.promo',
        isAllow: isAllow(rules, 'booking.promo'),
        subs: [
            {
                name: 'Афиши ',
                to: '/booking/afishi',
                text: 'booking_afishi',
                navKey: 'booking.promo.afishi',
                isAllow: isAllow(rules, 'booking.promo.afishi'),
            },
            {
                name: 'Список промоутеров ',
                to: '/booking/promouters',
                text: 'booking_promouters',
                navKey: 'booking.promo.promouters',
                isAllow: isAllow(rules, 'booking.promo.promouters'),
            },
        ],
    },
];

export default booking;
